import { Controller } from '@hotwired/stimulus'

/* Builds the canonical /calendar/:date/:view?destination_id=… URL from the
   filter form on submit, instead of letting the browser do a default GET
   (which would put `date` in the query string and fall through to the
   route's `view: 'day'` default). */
export default class extends Controller {
  static values = { base: String, view: String }

  submit(event) {
    event.preventDefault()

    const fd = new FormData(this.element)
    const date = fd.get('date') || ''
    const destinationId = fd.get('destination_id') || ''
    const view = this.hasViewValue ? this.viewValue : 'day'
    const base = this.hasBaseValue ? this.baseValue : this.element.getAttribute('action')

    let url = base.replace(/\/+$/, '')
    if (date) url += `/${date}`
    if (view) url += `/${view}`
    if (destinationId) url += `?destination_id=${encodeURIComponent(destinationId)}`

    window.location.href = url
  }
}
